<!-- src/apps/secret/components/conceal/landing/TerminalWindow.vue -->

<script setup lang="ts">
  import CornerBrackets from '@/shared/components/ui/CornerBrackets.vue';
  import { useI18n } from 'vue-i18n';

  const { t } = useI18n();

  // Status pills shown in the title bar. Every claim here must stay true to
  // the backend: encryption at rest + automatic expiry (TTL). Nothing about
  // client-side crypto or "no logs" — this deployment does neither.
  const statuses = ['landing.terminal.secure_channel', 'landing.terminal.encrypted_at_rest', 'landing.terminal.ephemeral'];
</script>

<template>
  <div
    class="relative border border-day-line-2 bg-day
      shadow-[0_0_0_1px_rgba(0,0,0,0.02),0_24px_64px_rgba(0,0,0,0.12)]
      dark:border-white/[0.13] dark:bg-night-100
      dark:shadow-[0_24px_64px_rgba(0,0,0,0.6)]">
    <!-- title bar -->
    <div
      class="flex h-9 items-center justify-between border-b border-day-line bg-day-200 px-4
        dark:border-white/[0.13] dark:bg-night-200">
      <div class="flex items-center gap-3">
        <span
          v-for="key in statuses"
          :key="key"
          class="flex items-center gap-1.5">
          <span
            class="inline-block size-[5px] shrink-0 rounded-full bg-brand-500 shadow-[0_0_6px_var(--color-brand-500)]"
            aria-hidden="true" ></span>
          <span
            class="font-mono text-[9px] uppercase tracking-[0.08em] text-day-ink-faint dark:text-night-ink-muted">
            {{ t(key) }}
          </span>
        </span>
      </div>
      <span
        class="hidden font-mono text-[9px] tracking-[0.1em] text-day-ink-faint dark:text-night-ink-faint sm:inline">
        AES-256
      </span>
    </div>

    <slot ></slot>

    <CornerBrackets />
  </div>
</template>
